import { useContext } from "react";
import { NavigationContext } from "@/providers/navigationProvider";
import styles from './styles.module.scss';

const TitleBar = () => {
    const context = useContext(NavigationContext);
    const {currentNavId, navItems} = context || {};
    let currentNavData = navItems && navItems.filter(item => item.id === currentNavId);
    currentNavData = currentNavData?.length > 0 ? currentNavData[0] : {};

    return(
        <div className={styles.titleBar}>
            {currentNavData?.label}
        </div>
    );
}

export default TitleBar;